/**
 * 游戏切换的状态控制
 */
import { setGameId } from "../services/service.js";
import { isPubg } from "@/views/zhiji/js/lib/businessCheck.js";
import i18n from "@/i18n";

export default {
    state: {
        gameId: getGameId(),
        robots: [], // 当前业务内容库列表
        curRobot: null, // 当前选择的内容库
        defaultLang: "",
        channels: []
    },
    mutations: {
        switchCurrentGame(state, data) {
            if (data.gameId != null) {
                window.localStorage.setItem("gameId", data.gameId);
            }
            window.location.reload();
        },
        switchGameId(state, gameId) {
            if (state.gameId != gameId) {
                state.gameId = gameId;
                window.localStorage.setItem("gameId", gameId);
                setGameId(gameId); // 设置services.js中请求统一添加gameId
            }
        },
        setRobots(state, robots) {
            state.robots.splice(0, state.robots.length, ...robots);

            // 设置当前内容库字段
            if (state.gameId && robots.length) {
                state.curRobot = state.robots.find(r => r.gameId == state.gameId);
                state.defaultLang = state.curRobot.defaultLang;

                // 兼容pubg已有的情况
                if (isPubg()) {
                    if (state.gameId == "80001") {
                        state.channels = effectChannelGrop().PUBGM;
                    } else if (state.gameId == "80002") {
                        state.channels = effectChannelGrop().CONTENT_BASE;
                    } else {
                        state.channels = effectChannelGrop().PUBGL;
                    }
                } else {
                    state.channels = state.curRobot.source.map(sc => ({ label: sc, value: sc }));
                }
            }
        }
    }
};

function getGameId() {
    let gameId = window.localStorage.getItem("gameId");
    return gameId ? gameId : "88888";
}

setGameId(getGameId());
window.localStorage.setItem("gameId", getGameId());

// pubg生效渠道分组
const effectChannelGrop = () => {
    return {
        PUBGL: [
            {
                label: i18n.t("zhiji.channel.SDKSet"),
                value: "sdk"
            },
            {
                label: i18n.t("zhiji.channel.SDKLogin"),
                value: "sdk_login"
            },
            {
                label: i18n.t("zhiji.channel.m_guest"),
                value: "m_guest"
            },
            {
                label: i18n.t("zhiji.channel.m_setting"),
                value: "m_setting"
            }
        ],
        PUBGM: [
            {
                label: i18n.t("zhiji.channel.H5Site"),
                value: "h5_safety"
            },
            {
                label: i18n.t("zhiji.channel.H5Scenes"),
                value: "h5_block"
            }
        ],
        // 内容助手：生效渠道
        CONTENT_BASE: [
            {
                label: "Mobile",
                value: "mobile"
            },
            {
                label: "Lite",
                value: "lite"
            }
        ]
    };
};
